import React from "react";
import { useWorkplace } from "../context/WorkplaceContext";

const Management = () => {
  const { selectedWorkplaceId } = useWorkplace(); // Context 사용
  return (
    <div>
      <h1>Management Page</h1>
      <p>This page is accessible only for logged-in users.</p>
      <p>(적용시 없앨 예정) Selected Workplace ID: {selectedWorkplaceId}</p>
      <br />
      <br />
      <br />
      <p>
        여기에 나중에.. 현장별 도면사진 업로드기능, 위치 숫자 셋팅하는거..
        이런거 해야 할듯.{" "}
      </p>
    </div>
  );
};

export default Management;
